var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":_vm.color,"dense":"","flat":_vm.flat,"dark":_vm.dark,"rounded":"lg"}},[_c('v-card-text',{class:_vm.cardclass},[(_vm.widgetData.loading && !_vm.alwaysrender)?_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":_vm.dark ? 'white' : 'primary'}}):(
        _vm.alwaysrender ||
        (_vm.widgetData.data && _vm.widgetData.data.ok && !_vm.widgetData.loading)
      )?_c('div',{staticClass:"headline",class:_vm.headlineclass},[_vm._t("content")],2):_c('div',{staticClass:"headline",class:_vm.headlineclass},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }